<div class="container-message">
  <div class="message-icon">
    <i class='far fa-exclamation-triangle'></i>
    <span>{{messageText}}</span>
  </div>
  <button *ngIf="buttonClose" (click)="closeContainerMessage()"><i class='fas fa-times'></i></button>
</div>

